import React, { useRef } from "react";
import { DEFAULT_CATALOG_PRODUCTS } from "../../constants/catalogData";

const FEATURES = [
  ["Ingredientes naturales", "M12 21c-5 0-8-3-8-8 5 0 8 3 8 8zM12 21c0-5 3-8 8-8 0 5-3 8-8 8zM12 21V6"],
  ["Alto en proteína", "M13 2L4 14h7l-1 8 9-12h-7z"],
  ["Sin conservantes artificiales", "M12 3l8 3v6c0 5-3 8-8 9-5-1-8-4-8-9V6z"],
  ["Disponibles 24/7", "M12 6v6l4 2M4 12a8 8 0 1 0 3-6M4 4v4h4"],
];

const css = `
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
.vc{--g:#2fbf3a;--lime:#b6f23c;--ink:#0e1a33;--mut:#5f6f86;position:relative;overflow:hidden;font-family:'Plus Jakarta Sans',system-ui,sans-serif;color:var(--ink);
background:radial-gradient(900px 500px at 78% 25%,#f7ffe9 0%,transparent 60%),linear-gradient(180deg,#f3fbe8 0%,#e4f5cf 100%);
padding:56px 0 44px;margin-top:-36px;border-radius:44px 44px 0 0;box-shadow:0 -24px 60px rgba(0,0,0,.45);border-top:1px solid rgba(255,255,255,.45);z-index:10}
.vc *{box-sizing:border-box}
.lf{position:absolute;border-radius:0 100% 0 100%;background:linear-gradient(135deg,#9bd75a,#4fa83a);filter:blur(5px);opacity:.55;pointer-events:none}
.vc-top{position:relative;max-width:1240px;margin:0 auto;padding:0 40px;display:grid;grid-template-columns:1.05fr 1fr;align-items:center;min-height:300px}
.bdg{display:inline-flex;align-items:center;gap:8px;background:rgba(255,255,255,.75);border:1px solid #cfe9b4;padding:8px 18px;border-radius:99px;font-size:12px;font-weight:700;color:#1f6a2a;letter-spacing:.04em}
.bdg i{width:7px;height:7px;border-radius:50%;background:var(--g)}
.vc h1{margin:18px 0 18px;font-size:clamp(44px,5.4vw,70px);line-height:.98;font-weight:800;letter-spacing:-.045em;color:var(--ink)}
.vc h1 span{display:block;background:linear-gradient(90deg,#1f9e3f,#5ed02a 70%,#9be02f);-webkit-background-clip:text;background-clip:text;color:transparent}
.sub{max-width:420px;color:var(--mut);font-size:16px;line-height:1.55;margin:0 0 28px}
.feat{display:flex;flex-wrap:wrap;gap:22px}
.ft{display:flex;align-items:center;gap:10px;font-size:12px;line-height:1.25;color:#33425a;max-width:110px;font-weight:500}
.ft b{flex:none;width:38px;height:38px;border-radius:50%;background:#dff3c8;display:grid;place-items:center;box-shadow:0 4px 10px rgba(80,160,40,.15)}
.ft svg{width:19px;height:19px;stroke:#1f7a2e;fill:none;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}
.hero{position:relative;display:flex;justify-content:center}
.hero img{width:100%;max-width:560px;display:block;-webkit-mask-image:radial-gradient(ellipse 60% 62% at 50% 50%,#000 62%,transparent 100%);mask-image:radial-gradient(ellipse 60% 62% at 50% 50%,#000 62%,transparent 100%)}

.car{position:relative;max-width:1340px;margin:8px auto 0;padding:0 64px}
.trk{display:flex;gap:12px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;padding:6px 4px 14px;scroll-behavior:smooth}
.trk::-webkit-scrollbar{display:none}
.pc{flex:0 0 140px;scroll-snap-align:start;background:rgba(255,255,255,.94);border-radius:20px;padding:12px 12px 14px;box-shadow:0 10px 26px rgba(70,120,40,.14);display:flex;flex-direction:column;gap:8px;min-height:242px;cursor:pointer}
.av{align-self:flex-start;font-size:8px;font-weight:700;color:#14632a;background:#cdf08f;padding:3px 8px;border-radius:99px;margin-bottom:-2px}
.pc img{width:100%;aspect-ratio:1/1.08;object-fit:cover;border-radius:14px;display:block}
.pc h3{margin:2px 0 0;font-size:12.5px;font-weight:700;line-height:1.2;min-height:30px;display:flex;align-items:center;color:#0e1a33}
.pt{align-self:flex-start;display:inline-flex;align-items:center;gap:5px;font-size:9px;font-weight:600;color:#2a6a35;background:#e7f6d6;border:1px solid #d3ecb9;padding:3px 8px;border-radius:99px}
.pt svg{width:9px;height:9px;stroke:#2fa23a;fill:none;stroke-width:2.4;stroke-linecap:round;stroke-linejoin:round}
.pr{display:flex;justify-content:space-between;align-items:center;margin-top:auto}
.pr b{font-size:13px;font-weight:800;color:#0e1a33}
.cart{width:26px;height:26px;border-radius:50%;border:0;background:linear-gradient(135deg,#2fbf3a,#1c9a35);display:grid;place-items:center;cursor:pointer;box-shadow:0 4px 10px rgba(30,150,50,.4)}
.cart svg{width:12px;height:12px;stroke:#fff;fill:none;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round}
.arw{position:absolute;top:50%;transform:translateY(-62%);width:38px;height:38px;border-radius:50%;border:0;background:#fff;display:grid;place-items:center;cursor:pointer;box-shadow:0 6px 16px rgba(0,0,0,.14);z-index:5}
.arw svg{width:16px;height:16px;stroke:#1f7a2e;fill:none;stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round}
.arw.l{left:18px}.arw.r{right:18px}
.pc:hover{transform:translateY(-4px);box-shadow:0 14px 30px rgba(50,110,30,.25)}.pc{transition:all .2s ease}
.dots{display:flex;justify-content:center;gap:6px;margin:6px 0 22px}
.dots i{width:16px;height:4px;border-radius:3px;background:#c9e5ae}.dots i:first-child{background:var(--g);width:18px}
.more{display:flex;justify-content:center}
.more button{display:inline-flex;align-items:center;gap:10px;padding:14px 34px;border:0;border-radius:99px;background:linear-gradient(90deg,#c3f640,#a5e82a);color:#12401c;font:800 13.5px 'Plus Jakarta Sans',sans-serif;cursor:pointer;box-shadow:0 8px 20px rgba(150,220,40,.4);transition:transform .2s ease}
.more button:hover{transform:scale(1.04)}
.arw:focus-visible,.cart:focus-visible,.more button:focus-visible{outline:3px solid #0e1a33;outline-offset:2px}
@media(max-width:900px){
  .vc-top{grid-template-columns:1fr;padding:34px 14px 0}
  .vc h1{font-size:clamp(28px, 7vw, 48px);line-height:1.05;margin:14px 0 10px}
  .sub{font-size:14px;line-height:1.5;margin-bottom:18px}
  .feat{gap:10px}
  .ft{max-width:none;flex:1 1 45%;font-size:11.5px}
  .hero img{max-width:320px;margin:16px auto 0}
  .car{padding:0 8px;margin-top:0}
  .arw{display:none}
}
@media(max-width:480px){
  .vc-top{padding:28px 12px 0}
  .car{padding:0 6px}
  .ft{flex:1 1 100%}
  .hero img{max-width:260px}
  .pc{flex:0 0 135px}
}
@media(prefers-reduced-motion:reduce){.pc{transition:none}.trk{scroll-behavior:auto}}
`;

const Ico = ({ d }) => <svg viewBox="0 0 24 24" aria-hidden="true"><path d={d} /></svg>;
const BOLT = "M13 2L4 14h7l-1 8 9-12h-7z";
const LEAF = "M12 21c-5 0-8-3-8-8 5 0 8 3 8 8zM12 21c0-5 3-8 8-8 0 5-3 8-8 8z";

export default function SnackCarousel({
  imgBase = "/catalog",
  products = DEFAULT_CATALOG_PRODUCTS,
  onProduct,
  onCatalog
}) {
  const trk = useRef(null);
  const go = (d) => trk.current?.scrollBy({ left: d * 280 });

  return (
    <section className="vc" id="catalogo">
      <style>{css}</style>
      <i className="lf" style={{ right: -40, top: 20, width: 220, height: 160, transform: "rotate(20deg)" }} />
      <i className="lf" style={{ left: -60, bottom: 40, width: 200, height: 130, transform: "rotate(-30deg)" }} />
      <i className="lf" style={{ right: -50, bottom: -30, width: 180, height: 140, transform: "rotate(40deg)" }} />

      <div className="vc-top">
        <div>
          <span className="bdg">CATÁLOGO VITTALINK</span>
          <h1>Snacks nutritivos.<span>Frescos 24/7.</span></h1>
          <p className="sub">Disfruta de una variedad de snacks saludables, seleccionados para darte energía, sabor y bienestar en cualquier momento.</p>
          <div className="feat">
            {FEATURES.map(([t, d]) => (
              <div className="ft" key={t}><b><Ico d={d} /></b>{t}</div>
            ))}
          </div>
        </div>
        <div className="hero">
          <img src={`${imgBase}/hero.jpg`} alt="Shake de vainilla VittaLink con bowl de frutos secos" />
        </div>
      </div>

      <div className="car">
        <button className="arw l" aria-label="Anterior" onClick={() => go(-1)}><svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7" /></svg></button>
        <div className="trk" ref={trk}>
          {products.map((p, i) => (
            <article
              className="pc"
              key={p.id || i}
              onClick={() => onProduct?.(p)}
              title="Haz clic para ver toda la información nutricional de este producto"
            >
              <span className="av">
                {p.isFeatured ? "⭐ DESTACADO" : "DISPONIBLE AHORA"}
              </span>
              <img
                src={p.img?.startsWith("/") || p.img?.startsWith("http") ? p.img : `${imgBase}/${p.img}.jpg`}
                alt={p.name}
                loading="lazy"
                onError={(e) => {
                  e.target.src = `${imgBase}/hero.jpg`;
                }}
              />
              <h3>{p.name}</h3>
              <span className="pt">
                {p.tag}
                <Ico d={p.tag?.toLowerCase().includes("prot") ? BOLT : LEAF} />
              </span>
              <div className="pr">
                <b aria-label={`${Number(p.rating ?? 5).toFixed(1)} de 5 estrellas`} style={{ color: "#334155", whiteSpace: "nowrap" }}>
                  <span style={{ color: "#eab308", letterSpacing: 1 }}>{Array.from({ length: 5 }, (_, index) => index < Math.round(Number(p.rating ?? 5)) ? "★" : "☆").join("")}</span> {Number(p.rating ?? 5).toFixed(1)}
                </b>
                <button
                  className="cart"
                  aria-label={`Ver detalles de ${p.name}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onProduct?.(p);
                  }}
                  title="Ver detalles completos"
                >
                  <Ico d="M12 5v14M5 12h14" />
                </button>
              </div>
            </article>
          ))}
        </div>
        <button className="arw r" aria-label="Siguiente" onClick={() => go(1)}><svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7" /></svg></button>
      </div>

      <div className="dots" aria-hidden="true"><i /><i /><i /><i /></div>
      <div className="more">
        <button onClick={onCatalog}>
          Ver más →
        </button>
      </div>
    </section>
  );
}
